import { TranslationKey, useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityUpdateAttribute } from '../../projectDetailsActivities.models';

export const UpdateAttributeActivity = ({ values }: IProjectActivity<IProjectActivityUpdateAttribute>): ReactElement => {
  const { t } = useTranslator();

  const properties: {
    name: TranslationKey;
    original: string | number | boolean;
    current: string | number | boolean;
  }[] = [];

  if (values.attribute !== values.originalAttribute) {
    properties.push({
      name: 'activity_description_common.name',
      original: values.originalAttribute,
      current: values.attribute,
    });
  }
  if (values.answerType !== values.originalAnswerType) {
    properties.push({
      name: 'activity_description_common.answerType',
      original: t(`${values.originalAnswerType}_question_type`),
      current: t(`${values.answerType}_question_type`),
    });
  }
  if (values.order !== values.originalOrder) {
    properties.push({
      name: 'activity_description_common.order',
      original: values.originalOrder,
      current: values.order,
    });
  }
  if (values.isRequired !== values.originalIsRequired) {
    properties.push({
      name: 'activity_description_common.isRequired',
      original: values.originalIsRequired,
      current: values.isRequired,
    });
  }

  return (
    <span>
      {t('activity_description_UpdateAttribute')}
      <b>{values.originalAttribute}</b>
      {t('activity_description_common.changed')}
      {properties.map((p) => t(p.name)).join(', ')} {t('activity_description_common.from')} <b>{properties.map((p) => p.original).join(', ')}</b>{' '}
      {t('activity_description_common.to')} <b>{properties.map((p) => p.current).join(', ')}</b>.
    </span>
  );
};
